import React from 'react';
import { useForm, Controller, useFieldArray } from 'react-hook-form';
import { TextField, IconButton, Box, Typography, Autocomplete, Button } from '@mui/material';
import { ReactComponent as PlushIcon } from "../../../assets/dashboardIcons/plusicon.svg"
import { ReactComponent as DeleteIcon } from "../../../assets/dashboardIcons/deleteIcon.svg"
import { ReactComponent as DropDown } from "../../../assets/dashboardIcons/SortIcon.svg"
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';

const schema = yup.object().shape({
    phases: yup.array().of(
        yup.object().shape({
            name: yup.string().required('Nome della fase è richiesto'),
            description: yup.string().max(120, 'Massimo 120 caratteri').required('Descrizione è richiesta'),
            priority: yup.string().required('Priorità è richiesta')
        })
    )
});

const options = ['Amministratore', 'Collaboratore', 'Operatore'];

const Fasi = () => {
    const { control, handleSubmit, formState: { errors } } = useForm({
        defaultValues: { phases: [{ name: '', description: '', priority: '' }] },
        resolver: yupResolver(schema)
    });

    const { fields, append, remove } = useFieldArray({ control, name: 'phases' });

    const onSubmit = (data) => {
        console.log('Form Data:', data);
    };

    return (
        <Box mt={1}>
            <Box p={1}  >
                <form onSubmit={handleSubmit(onSubmit)}>
                    {fields.map((phase, index) => (
                        <Box
                            key={phase.id}

                            alignItems="center"
                            gap={2}
                            mb={1}
                            p={2}
                            sx={{ backgroundColor: '#F7F7F7', borderRadius: "10px" }}
                        >
                            {/* Fixed the field names to properly link with the control and errors */}
                            <Box sx={{ display: "grid", gridTemplateColumns: "1fr 230px 32px", gap: "20px" }}>
                                <Controller
                                    name={`phases.${index}.name`}
                                    control={control}
                                    render={({ field }) => (
                                        <Autocomplete
                                            {...field}
                                            options={options}
                                            onChange={(_, value) => field.onChange(value)}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label="Nome della fase"
                                                    margin="normal"
                                                    className='customTextBox autoCompleteTextBox'
                                                    fullWidth
                                                    error={!!errors.phases?.[index]?.name}
                                                    helperText={errors.phases?.[index]?.name?.message}
                                                />
                                            )}
                                        />
                                    )}
                                />

                                <Controller
                                    name={`phases.${index}.priority`}
                                    control={control}
                                    render={({ field }) => (
                                        <Autocomplete
                                            {...field}
                                            options={options}
                                            onChange={(_, value) => field.onChange(value)}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    className='customTextBox autoCompleteTextBox'
                                                    label="Priorità"
                                                    margin="normal"
                                                    fullWidth
                                                    error={!!errors.phases?.[index]?.priority}
                                                    helperText={errors.phases?.[index]?.priority?.message}
                                                />
                                            )}
                                        />
                                    )}
                                />
                                <IconButton sx={{ height: "30px", width: "30px" }} onClick={() => remove(index)} color="primary" size="small">
                                    <DeleteIcon />
                                </IconButton>
                            </Box>
                            <Box sx={{ display: "grid", gridTemplateColumns: "1fr 32px", gap: "20px" }}>
                                <Controller
                                    name={`phases.${index}.description`}
                                    control={control}
                                    render={({ field }) => (
                                        <TextField
                                            {...field}
                                            label="Descrizione (Massimo 120 caratteri)"
                                            fullWidth
                                            margin="normal"
                                            className='customTextBox '
                                            error={!!errors.phases?.[index]?.description}
                                            helperText={errors.phases?.[index]?.description?.message}
                                        />
                                    )}
                                />
                                <IconButton sx={{ height: "30px", width: "30px" }} color="primary" size="small">
                                    <DropDown />
                                </IconButton>
                            </Box>

                        </Box>
                    ))}
                </form>
            </Box>
            <Button
                variant="body2"
                onClick={() => append({ name: '', description: '', priority: '' })}
                sx={{
                    cursor: 'pointer', color: "#225CA6", mt: 1, gap: "6px",
                    fontFamily: '"Public Sans", sans-serif !important',
                    '&:hover': {
                        color: '#57C700',
                        background: "transparent"
                    }
                }}
            >
                <PlushIcon

                /> aggiungi fase
            </Button>
        </Box>
    );
};

export default Fasi;
